import { useState, useEffect } from 'react'; // ✅ Added useEffect
import LoginForm from './components/LoginForm';
import { useLogin } from './hooks';
import './Login.css';
import LoadingIndicator from 'components/LoadingIndicator';
import Footer from 'components/Footer/Footer';
import { AssetUrls } from 'config/assets';
import { SEOHelmet, OrganizationSchema } from 'components/SEO';
import LandingPageContent from './components/LandingPageContent';

export const Login = () => {
  const loginProps = useLogin();
  const [imageLoaded, setImageLoaded] = useState(false);
  const [activeTab, setActiveTab] = useState(2); // Default to Join TradeMagic tab
  const [prefilledEmail, setPrefilledEmail] = useState('');

  const handleTabChange = (tab: number, email?: string) => {
    setActiveTab(tab);
    if (email !== undefined) setPrefilledEmail(email);
  };

  const onBigImageLoaded = () => {
    setImageLoaded(true);
  };

  // ✅ Add and clean up the landing-page class
  useEffect(() => {
    document.body.classList.add('landing-page');
    return () => {
      document.body.classList.remove('landing-page');
    };
  }, []);

  return (
    <>
      {/* SEO Meta Tags for Homepage/Login */}
      <SEOHelmet
        title="TradeMagic - Trade Magic: The Gathering Cards For Free"
        description="The easiest way to trade MTG cards. Join the best community of Magic players trading cards by mail."
        canonical="https://trademagic.gg/"
        keywords="MTG trading, Magic the Gathering trade, trade MTG cards, Magic card exchange, MTG marketplace, trade Magic cards online, Cube trading, Commander trading, EDH card exchange, Pauper trading, alternative to TCGPlayer, CardKingdom alternative, Cardsphere alternative"
        type="website"
      />
      <OrganizationSchema includeWebSite={true} />

      <div className="login-page-wrapper">
        <div className="login-page-content">
          <img
            className="logo-main"
            src={AssetUrls.logos.black}
            alt="magictrade-logo-black"
            width="279"
            height="54"
          />
          <LoginForm
            {...loginProps}
            activeTab={activeTab}
            onTabChange={handleTabChange}
            prefilledEmail={prefilledEmail}
          />
          <img
            className="login-background-artist"
            width={107}
            height={26}
            src={AssetUrls.login.backgroundArtist}
            alt="login-background-artist"
            onLoad={onBigImageLoaded}
          />
          <p className="tagline">
            A private card trading club powered by players
          </p>
          {!imageLoaded && <LoadingIndicator isScreen />}
        </div>

        <LandingPageContent />

        <Footer />
      </div>
    </>
  );
};
